import { useContent } from "@/context/ContentContext";
import { resolveImg } from "@/lib/api";

const VEIL = "linear-gradient(90deg,rgba(13,13,13,.8) 0%,rgba(13,13,13,.35) 60%,rgba(13,13,13,.1) 100%)";

export const BleedQuote = () => {
  const { bleed_1: b } = useContent();

  return (
    <section className="bleed" style={{ minHeight: "min(90vh,860px)", display: "flex", alignItems: "center" }} data-testid="bleed-quote">
      {b?.image_url && <img src={resolveImg(b.image_url)} alt="" />}
      <div className="veil" style={{ background: VEIL }} />
      <div className="in wrap" style={{ width: "100%" }}>
        <p className="h hx" style={{ maxWidth: 1100 }}>
          {b?.title} <span className="ac">{b?.title_accent}</span>
        </p>
        <p className="lead" style={{ marginTop: 28 }}>{b?.lead}</p>
      </div>
    </section>
  );
};
